import { render, staticRenderFns } from "./receive-payment-dialog.vue?vue&type=template&id=4bd7162c&scoped=true&"
import script from "./receive-payment-dialog.vue?vue&type=script&lang=ts&"
export * from "./receive-payment-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./receive-payment-dialog.vue?vue&type=style&index=0&id=4bd7162c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd7162c",
  null
  
)

export default component.exports